import { render, staticRenderFns } from "./sfc-sponsored-plan-interstitial-v1.vue?vue&type=template&id=3588c404&scoped=true&lang=pug&"
import script from "./sfc-sponsored-plan-interstitial-v1.vue?vue&type=script&lang=js&"
export * from "./sfc-sponsored-plan-interstitial-v1.vue?vue&type=script&lang=js&"
import style0 from "./sfc-sponsored-plan-interstitial-v1.vue?vue&type=style&index=0&id=3588c404&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3588c404",
  null
  
)

export default component.exports